import { ChangeDetectorRef, Component, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import EventEmitter from 'events';
import { NgxSpinnerService } from 'ngx-spinner';
import { columnsDef } from 'src/app/interfaces/columnsDef';
import { DynamicFormsService } from 'src/app/services/dynamic-forms.service';
import { HTTPService } from 'src/app/services/http.service';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { UserAuthenticationServices } from 'src/app/services/user-authentication.services';
import { ObjectUtil } from 'src/app/system-utils/utils/ObjectUtil';
import { DialogService } from '../../../../services/dialog.service';
import { MeliAttributesComponent } from './meli-attributes/meli-attributes.component';
import { MeliVariationComponent } from './meli-variation/meli-variation.component';
import { VariationMeliPopupComponent } from './variation-meli-popup/variation-meli-popup.component';
import { ThemeService } from 'src/app/services/theme.service';

@Component({
    selector: 'meli-item',
    templateUrl: './meli-item.component.html',
    styleUrls: ['./meli-item.component.scss'],
    standalone: false
})
export class MeliItemComponent implements OnInit, OnChanges {
  resultado: any;
  showVariationAlert = false;
  message: string ='';
  constructor( private dialogServices:DialogService, private uid:UserAuthenticationServices, private spinner:NgxSpinnerService, private http:HTTPService,
    private dynaServices:DynamicFormsService, public ThemeService:ThemeService,private form:UntypedFormBuilder, private cd:ChangeDetectorRef, private snackBar:SnackbarService) {

      this.formInicial = form.group({});
      
     }
  

  @Input()melidata:Object;
  @Input()mktpmeli:Object[];
  @Input()codeCompany:Number;
  @Output()selectProduct:EventEmitter = new EventEmitter();
  formInicial:UntypedFormGroup;
  spinnerName:string;
  selectedProduct:object;
  itemselected = false;
  
  ngOnInit(): void {
      this.spinnerName = this.melidata['id'];
      this.checkMeliVar()
  } 
  
  checkMeliVar() {
      let byId = false;
      let hasVariations = false;

      if( this.melidata['variations'] !=null){
        if ( this.melidata['variations'].length > 0 ){
          byId = true;
          hasVariations = true;
        }else{
          byId = true;
          hasVariations = false;
        }
      } 

      if ( this.melidata['variations_data']!= null ){
        if (Object.keys(this.melidata['variations_data']).length > 0 ){
          byId = false;
          hasVariations = true;
        }else{
          hasVariations = false;
        }
      }

      if ( hasVariations ){
        let arrayVar:Object[]  = byId ?  this.melidata['variations'] :Object.keys(this.melidata['variations_data']);
        
        if ( this.melidata['VARIACAO']=='' || this.melidata['VARIACAO']==null ){
          this.showVariationAlert = true;
          this.message = `Não existe nenhuma variação importada. Anúncio contém ${arrayVar.length} variação(es).`
        }else{
            let variacaoBase:string[]  = (this.melidata['VARIACAO'] as String).split(';');  
            
            if ( byId ){
              let variations:object[] = this.melidata['variations'];
              if ( variations!= null && variations.length > 0 ){      
                variations.forEach(variacao=>{    
                    if ( variacaoBase.findIndex(d=>d == variacao['id'])== -1 ){
                        this.showVariationAlert = true;
                        this.message += 'Não encontrado Id.Variação: '+variacao['id']+";"+'<br/>';
                    }
                })
              } 
            }else{
              let variations_data:object = this.melidata['variations_data'];
              if ( variations_data!= null && Object.keys(variations_data).length > 0 ){      
                  Object.keys(variations_data).forEach(idvariacao=>{    
                      if ( variacaoBase.findIndex(d=>d == idvariacao)== -1 ){
                          this.showVariationAlert = true;
                          this.message += 'Não encontrado Id.Variação: '+idvariacao+";"+'\n';
                      }
                  })
              } 
            }
        }
      }

      
      
  }

  importar(event:Event){
    event.stopPropagation();
    event.preventDefault();
    
    if ( this.itemselected ){
        this.dialogServices.errorDialoag = false;
        this.dialogServices.title = "Atenção";
        this.dialogServices.infoDialog = true;
        this.dialogServices.openNewDialog(`Já existe anúncio importado. Deseja importar apenas as variações?`,(data)=>{
            if ( data ){
              this.importarProduto(true);
            }else{
              this.importarProduto(false);
            }
        }
        ,null, false);
    }else{
      this.importarProduto(false);
    }
    
  }

  importarProduto(sovariacao:boolean=false){

    let columnDef:columnsDef = {
      COLUMNNAME: 'FK_MKTPMELI_MKTPPRODUCTS->NAME',
      COLUMNDESC: 'FK_MKTPMELI_MKTPPRODUCTS->NAME',
      DATATYPE: 'VARCHAR',
      IDCOLUMN: 1,
      ISIDENTITY: 0,
      ISPK: 1,
      VISIBLE: 1,
      PLACEHOLDER: 'FK_MKTPMELI_MKTPPRODUCTS->NAME',
      ISREQUIRED:0,
      LINE:0,
      CELL:0,
      tab:''
    }

      if ( sovariacao ){
          this.createProduct(sovariacao);
      }else{
       
        this.dialogServices.disableClose = true;
        this.dialogServices.openFindDialog('Mktpproducts','Cadastro de Produtos',this.dynaServices,this.formInicial,columnDef,(data)=>{
          if ( !data){
            this.snackBar.showInformation("Processo abortado pelo usuário.");
            return;
          }else{
            this.selectedProduct = JSON.parse(JSON.stringify(data));
            this.createProduct(sovariacao);
          }
        });
      }
    
    }

    createProduct(sovariacao=false){
    
    let ob = {
      codeCompany :this.codeCompany,
      method: 'GET',
      serviceName: 'GetItem',
    }

    ob['params'] = [{key:'@MLB', value: this.melidata['id']}];

    this.spinner.show(this.spinnerName);
    this.http.post(ob,'MeliNotifications/getGenericMeli',false,true,false).subscribe(result=>{
        this.resultado = result['resultado'];
        let obdesc = {
          codeCompany : this.codeCompany,
          method: 'GET',
          serviceName: 'GetItemDesc',
        }

        obdesc['params'] = [{key:'@MLB', value: this.melidata['id']}];

        this.http.post(obdesc,'MeliNotifications/getGenericMeli',false,true,false).subscribe(result=>{
          let desc = result['resultado'];
          this.resultado['description'] = desc['plain_text'];

          let variations:Object[] = this.resultado['variations']
          
          if ( !ObjectUtil.isNotEmpty(variations) && sovariacao){
              this.snackBar.showInformation("Anúncio não possui variações. Processo abortado."); 
              this.spinner.hide(this.spinnerName);
              return;
          }

          if ( ObjectUtil.isNotEmpty(variations)){
            if ( variations.length > 0 ){
              this.dialogServices.openGenericDialog(VariationMeliPopupComponent,variations,(popUpData)=>{
                this.resultado['variations'] = popUpData;
                this.processData(sovariacao);
             },()=>{
                this.snackBar.showInformation("Processo abortado pelo usuário.");
                this.spinner.hide(this.spinnerName);
             });   
            }else{
              this.processData(sovariacao);
            }
          }else{
            this.processData(sovariacao);
          }
          
        },
        error=>{
          this.spinner.hide(this.spinnerName);
          throw error;
        });  
    },
    error=>{
        this.spinner.hide(this.spinnerName);
        throw error;
    });


  }

  processData(sovariacao:boolean=false){

    let pro = {
      codeCompany: sovariacao ? this.melidata['CODECOMPANY']: this.codeCompany,
      codeProduct: sovariacao ? this.melidata['CODEPRODUCT']: this.selectedProduct["CODEPRODUCT"],
      codeContract: sovariacao ? this.melidata['CODECONTRACT']: this.selectedProduct["CODECONTRACT"] , 
      data: this.resultado,
      sovariacao: sovariacao,
      type:"import"
    }

    if ( sovariacao){
      pro['CODEMELI'] = this.melidata['CODEMELI'];
    }
    
    this.http.post(pro, 'MeliNotifications/createProduct',false,true,false).subscribe(c=>{  
        this.itemselected = true;
        this.spinner.hide(this.spinnerName);
        this.cd.detectChanges();
        this.snackBar.showSuccess("Produto relacionado com sucesso.");
    },
    error=>{
      this.spinner.hide(this.spinnerName);
      throw error;
    })

  }

  openDetails(event:Event){

    event.stopPropagation();
    event.preventDefault();
    this.dialogServices.openGenericDialog(MeliAttributesComponent,this.melidata);
    
  }

  openVariations(event:Event){
      event.stopPropagation();
      event.preventDefault();
      this.dialogServices.openGenericDialog(MeliVariationComponent,this.mktpmeli);
    
  }

  ngAfterViewInit(){
      
      if ( this.melidata['hasproduct']){
          this.itemselected = true;
      }else{
        this.itemselected = false;
      }
  }

  ngOnChanges(changes: SimpleChanges): void {
     if ( this.melidata['hasproduct']){
       this.itemselected = true;
     }else{
       this.itemselected = false;
     }
  }
}
